export default function () {
  var u = navigator.userAgent
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isIOS) {
    if (screen.height === 812 && screen.width === 375) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js